import React from 'react';
import Ads from '../Ads/Ads';

import { Foot } from '../Foot/Foot';
import Footer from '../Footer/Footer';
import TopBar from '../TopBar/TopBar';
import "./home.css"
import { HomeNews } from './HomeNews/HomeNews';
import TopicSecion from './TopicSecion/TopicSecion';

function Home() {
  return (
    <div className='home'>
      <TopBar />
      <TopicSecion />
      <Ads />
      <HomeNews />
      <Ads />
      <Footer /> 
      <Foot />
    </div>
     
  )
}

export default Home